// extracted by mini-css-extract-plugin
export default {"scale-holder":"scale-holder","grade-txt":"grade-txt","scale-txt":"scale-txt"};